import { Market } from '@bridebook/toolbox/src/gazetteer';
import type { IArticle, PostAuthor } from '@bridebook/toolbox/src/schemas/article/types';
import { env } from '@bridebook/web/lib/env';
import { PublicUrls } from '@bridebook/web/lib/url-helper';

export function authorSchema(author: PostAuthor, market: Market) {
  const description = author.description?.[market.language] ?? undefined;

  const result: Record<string, unknown> = {
    '@context': 'https://schema.org/',
    '@type': 'Person',
    name: author.display_name,
    url: `${env.COUPLESIDE_URL}/${market.prefix}${PublicUrls.author.nameSurname(`${author.first_name}-${author.last_name}`.toLowerCase())}`,
    worksFor: {
      '@type': 'Organization',
      name: 'Bridebook',
      url: env.COUPLESIDE_URL,
    },
    sameAs: [author.linkedin, author.instagram, author.bb_tiktok].filter(Boolean),
  };

  if (author.bb_job_title) {
    result.jobTitle = author.bb_job_title;
  }

  if (author.profile_image?.full) {
    result.image = author.profile_image.full;
  }

  if (description) {
    result.description = description;
  }

  return result;
}

export function articleSchema(article: IArticle, market: Market) {
  const result = {
    '@context': 'https://schema.org/',
    '@type': 'Article',
    author: {
      '@type': 'Person',
      name: article.post_author.display_name,
      url: `${env.COUPLESIDE_URL}/${market.prefix}${PublicUrls.author.nameSurname(`${article.post_author.first_name}-${article.post_author.last_name}`.toLowerCase())}`,
    },
    dateModified: new Date(article.post_modified).toISOString(),
    datePublished: new Date(article.post_date).toISOString(),
    description: article.seo_metadesc ?? undefined,
    headline: article?.seo_title || article.title,
    image: {
      '@type': 'ImageObject',
      url: article.featured_image.source,
    },
    mainEntityOfPage: {
      '@id': `${env.COUPLESIDE_URL}/${market.prefix}${PublicUrls.article.id(article.slug)}`,
      '@type': 'WebPage',
    },
    publisher: {
      '@type': 'Organization',
      logo: {
        '@type': 'ImageObject',
        height: '59',
        url: 'https://assets-global.website-files.com/64774f156d2d2c0eadd45966/64834cce223b83ebf5484a28_Bridebook-logo-blue.svg',
        width: '420',
      },
      name: 'Bridebook',
      url: env.COUPLESIDE_URL,
    },
  };

  if (article.post_author.profile_image?.full != null) {
    // @ts-expect-error
    result.author.image = {
      '@type': 'ImageObject',
      url: article.post_author.profile_image?.full,
    };
  }

  return result;
}
